function attachSizeGuideTriggers() {
  document.querySelectorAll('.size-guide-trigger[data-size-guide-option]').forEach(function (trigger) {
    var blockId = trigger.getAttribute('data-block-id');
    var optionName = (trigger.getAttribute('data-size-guide-option') || '').trim().toLowerCase();
    if (!blockId || !optionName) return;

    var picker = document.querySelector('variant-picker[data-block-id="' + blockId + '"]');
    if (!picker) return;

    var labels = picker.querySelectorAll('fieldset > legend, .variant-option--dropdowns > label');
    var target = null;
    labels.forEach(function (label) {
      if (target) return;
      var text = label.textContent.trim().toLowerCase();
      if (text.indexOf(optionName) === 0) {
        target = label;
      }
    });

    if (target && !target.contains(trigger)) {
      trigger.removeAttribute('hidden');
      target.appendChild(trigger);
    }
  });
}

attachSizeGuideTriggers();

var sizeGuideObserver = new MutationObserver(attachSizeGuideTriggers);
sizeGuideObserver.observe(document.documentElement, { childList: true, subtree: true });
setTimeout(function () {
  sizeGuideObserver.disconnect();
}, 8000);